import { Navigate, Outlet, Route, Routes } from 'react-router-dom'

import { Equipment } from '@/features/equipamentos/pages/equipment'
import { EquipmentVista } from '@/features/equipamentos/pages/equipment-vista'
import { EquipmentVistaItem } from '@/features/equipamentos/pages/equipment-vista-item'

export default function Component() {
  return (
    <Routes>
      <Route index element={<Equipment.List />} />
      <Route path="novo" element={<Equipment.Create />} />
      <Route path=":equipment_id" element={<Outlet />}>
        <Route index element={<Equipment.Dashboard />} />
        <Route path="editar" element={<Equipment.Edit />} />
        <Route path="vistas" element={<Outlet />}>
          <Route path="novo" element={<EquipmentVista.Create />} />
          <Route path=":vista_id" element={<Outlet />}>
            <Route index element={<EquipmentVista.Dashboard />} />
            <Route path="editar" element={<EquipmentVista.Edit />} />
            <Route path="itens/editar" element={<EquipmentVistaItem.Edit />} />
          </Route>
          <Route />
        </Route>
        <Route path="*" element={<Navigate to="" />} />
      </Route>
    </Routes>
  )
}
